import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Loading from "components/ui/Loading";
import { getAdminUser } from "store/admin/api/apiSlice";
import * as Styled from "./styled";
import Expenses from "./Expenses";
import Danger from "./Danger";
import BasicInfo from "./BasicInfo";
import UnresolvedIntegrationErrors from "./UnresolvedIntegrationErrors";
import LinkedBankAccount from "./LinkedBankAccount";
import Pave from "./Pave";
import SpendingLimit from "./SpendingLimit";
import IncomeEmployment from "./IncomeEmployment";
import Payroll from "./Payroll";
import PlaidTransactions from "./PlaidTransactions";
import Repayments from "./Repayments";

const InactiveBanner = styled.div`
  background-color: #fef2f2;
  border: 2px solid #fca5a5;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: "⚠️";
    font-size: 24px;
  }
`;

const InactiveBannerText = styled.div`
  color: #dc2626;
  font-weight: 600;
  font-size: 16px;
`;

const User = () => {
  const { id } = useParams();
  const { data: user, isLoading, refetch: refetchUser } = getAdminUser(id);

  if (isLoading) return <Loading />;

  if (!user) {
    window.location.replace("/admin/users");
    return null;
  }

  const { recurringExpenses } = user || {};

  return (
    <Styled.Wrapper>
      {user.userConfig.inactive && (
        <InactiveBanner>
          <InactiveBannerText>
            This user is marked as INACTIVE and may have limited functionality.
          </InactiveBannerText>
        </InactiveBanner>
      )}

      <Styled.SectionGroup>
        <BasicInfo user={user} />

        <SpendingLimit user={user} />

        <IncomeEmployment user={user} />

        <Payroll user={user} />

        <LinkedBankAccount user={user} />

        <Expenses expenses={recurringExpenses} />

        <Pave user={user} />
      </Styled.SectionGroup>

      <PlaidTransactions user={user} />

      <Repayments user={user} refetchUser={refetchUser} />

      <UnresolvedIntegrationErrors user={user} />

      {!user.admin && <Danger user={user} refetchUser={refetchUser} />}
    </Styled.Wrapper>
  );
};

export default User;
